import React from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "@/assets/logo/logo-icon.png";
import TextLogo from "@/assets/logo/text-logo.png";
import { OtherLinks, SidebarLinks } from "@/constant";
import SidebarLink from "./SidebarLink";
import { SidebarGenerator } from "@/utils/sidebarGenerator";
import CommunityIcon from "@/assets/icons/Community.svg";
import SignOutIcon from "@/assets/icons/SignOutIcon.svg";
import { useAppDispatch, useAppSelector } from "@/redux/hooks/hooks";
import { logOut } from "@/redux/feature/auth/authSlice";
import { useGetMeQuery } from "@/redux/feature/user/userApi";
import { usePricingFormula } from "@/hooks/usePricingFormula";
import { useAiMarketplaceRedirect } from "@/hooks/useAiAppRedirection";
import IntelligenceButton from "@/components/ui/IntelligenceButton";

export type SideBarProps = {
  isExpanded?: boolean;
  setExpanded?: React.Dispatch<React.SetStateAction<boolean>>;
  isIntelligenceModalOpen: boolean;
  setIsIntelligenceModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const SideBar = ({
  setExpanded,
  isExpanded,
  isIntelligenceModalOpen,
  setIsIntelligenceModalOpen,
}: SideBarProps) => {
  const location = useLocation();
  const pathname = location.pathname;
  const { user, token } = useAppSelector((state) => state.auth);
  const { data } = useGetMeQuery(user?.email);
  // const userData: TUser | undefined = data?.data;
  const { ucdT } = usePricingFormula();
  const isIndian = ucdT?.country === "IN";

  const filteredLinks = !isIndian
    ? SidebarLinks.filter((item) => item.path !== "templates")
    : SidebarLinks;

  const { redirect: handleAiMarketPlaceRedirect } = useAiMarketplaceRedirect({
    setModalOpen: setIsIntelligenceModalOpen, // optional
  });

  return (
    <>
      {/* Desktop Sidebar */}
      <div className="hidden md:flex flex-col h-screen py-6 px-3">
        <div
          onClick={() => setExpanded?.(!isExpanded)}
          className="px-3 flex items-center gap-x-2 cursor-pointer py-[10px]"
        >
          <img src={logo} alt="passionbits-logo" />
          {isExpanded && <img src={TextLogo} alt="text-logo" />}
        </div>

        <div className="mt-3 flex-1 h-full overflow-y-scroll">
          <ul className="">
            {SidebarGenerator(filteredLinks).map((item, i) => (
              <SidebarLink
                isExpanded={isExpanded}
                pathname={pathname}
                data={item}
                key={i}
              />
            ))}
            {/* intelligence button */}
            <button>
              <Link to={"/"}>
                <IntelligenceButton
                  isExpanded={isExpanded as boolean}
                  isIntelligenceModalOpen={isIntelligenceModalOpen}
                />
              </Link>
            </button>
          </ul>
          <div>
            <ul>
              {SidebarGenerator(OtherLinks).map((item, i) => (
                <SidebarLink
                  isExpanded={isExpanded}
                  pathname={pathname}
                  data={item}
                  key={i}
                />
              ))}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default SideBar;

interface SignOutButtonProps {
  isExpanded: boolean;
}

const SignOutButton = ({ isExpanded }: SignOutButtonProps) => {
  const dispatch = useAppDispatch();
  const handleLogout = () => dispatch(logOut());

  return (
    <li className="h-[70px] md:h-[40px]">
      <button
        onClick={handleLogout}
        className={`mt-3 px-4 py-2 flex h-full md:justify-start justify-center flex-col md:flex-row gap-x-1 w-full items-center transform ease-in-out transition-all text-[#62636C] bg-white border-none`}
      >
        <div className="w-[20px]">
          <SignOutIcon />
        </div>
        {isExpanded && (
          <p
            className={`${
              isExpanded ? "opacity-100" : "w-[0px] opacity-0"
            } whitespace-nowrap transform ease-in-out transition-all duration-300 font-medium text-sm leading-5 tracking-[-0.75%]`}
          >
            Sign out
          </p>
        )}
        <p className="whitespace-nowrap font-medium text-xs mt-1 block md:hidden">
          Sign out
        </p>
      </button>
    </li>
  );
};
